import api from "PFCore/api";

export type SignUpPayload = {
  accountId: number;
  email: string;
  password: string;
  passwordConfirmation: string;
};

type SignUpResponse = {
  message: string;
};

export const signUp = ({ accountId, email, password, passwordConfirmation }: SignUpPayload) =>
  api<SignUpResponse>({
    url: "auth/sign_up",
    method: "POST",
    apiVersion: 1,
    data: {
      user: {
        accountId,
        email,
        password,
        passwordConfirmation
      }
    }
  });
